export default "<div class=\"console\">\n  <pre>{{healthData}}</pre>\n</div>"